export default function isRightAlign(position) {
  return position === 'bottom right' || position === 'top right';
}